var _defineProperty = require("/codebuild/output/src2820/src/s3/01/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var constants = require('./constants');
var se = require('./se');
var fi = require('./fi');
var no = require('./no');
var dk = require('./dk');
var parse = function parse(nationalId, market) {
  switch (market) {
    case 'se':
      return se.parse(nationalId);
    case 'fi':
      return fi.parse(nationalId);
    case 'no':
      return no.parse(nationalId);
    case 'dk':
      return dk.parse(nationalId);
    default:
      if (!market) {
        throw new Error('Undefined market');
      }
      throw new Error("".concat(market, " not recognized as a valid market."));
  }
};
module.exports = _objectSpread({
  parse: parse
}, constants);